import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import "./Fonts/AlexBrush/AlexBrush-Regular.ttf";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./DocPlace/LoginSAML/authConfig";
import { ThemeProvider } from "@material-ui/core/styles";
import muiTheme from "./theme/muiTheme";

// Suppress React lifecycle deprecation warnings from dependencies (e.g. @material-ui/core v4, styled-components)
if (process.env.NODE_ENV === "development") {
  const originalError = console.error;
  console.error = (...args) => {
    const msg = args[0];
    if (
      typeof msg === "string" &&
      (msg.includes("componentWillMount") ||
        msg.includes("componentWillReceiveProps") ||
        msg.includes("UNSAFE_component"))
    ) {
      return;
    }
    originalError.apply(console, args);
  };
}

const msalInstance = new PublicClientApplication(msalConfig);

const app = (
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={muiTheme}>
        <App />
      </ThemeProvider>
    </MsalProvider>
  </Provider>
);

if (window.location.hash !== "") {
  console.log("hash found" + window.location.hash);
} else {
  ReactDOM.render(app, document.getElementById("root"));
}
